export default __webpack_public_path__ + "static/pupfection-3dabc41f0a74ebe691e777e82501f72c.svg";